<script setup lang="ts">
import { units } from '~/constants/fileUnits'

const { getResourceUrl } = useResources()

const props = defineProps<{
  pressNid: number
}>()

const { data: pressDetail, status } = await useLazyAsyncData(
  `press-detail-${props.pressNid}`,
  () => createPressesRepository().getPressDetail(props.pressNid)
)

// Inspired by FilePreview.vue
// TODO: move into composable?
function formattedSize() {
  const size = Number(pressDetail.value?.file?.fileSize ?? '0')
  for (const [unit, inBytes] of Object.entries(units)) {
    if (size >= inBytes) {
      const unitSize = size / inBytes
      return Math.round(unitSize) + unit
    }
  }
}

const fileExtension = pressDetail.value?.file?.fileName?.split('.').pop() ?? ''
const fileSize = formattedSize()

const formattedDate = ref('')

watch(pressDetail, () => {
  if (pressDetail.value) {
    formattedDate.value = new Intl.DateTimeFormat('cs-CZ', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(new Date(pressDetail.value?.date))
  }
})
</script>

<template>
  <div v-if="status === 'pending'">
    <div class="flex flex-col gap-5">
      <UiSkeletonPressCard v-for="_ in 5" />
    </div>
  </div>
  <NuxtLink
    v-else
    :to="getResourceUrl(pressDetail?.file?.url)"
    :title="$t('aboutCompany.press.download', [pressDetail?.title])"
    class="no-underline"
  >
    <div class="bg-neutral-100 p-7">
      <div class="flex">
        <div class="mr-9">
          <img
            :src="getResourceUrl(pressDetail?.icon?.url)"
            :alt="pressDetail?.title"
            height="50"
            width="50"
            loading="lazy"
            class="object-fill"
          />
        </div>
        <p class="px-2">
          <span class="font-pragmatica-ext text-base font-bold">
            {{ pressDetail?.title }}
          </span>
          <br />
          <small class="text-sm text-neutral-500">
            <time :datetime="formattedDate">
              {{ formattedDate }}
            </time>
            —
            {{ fileExtension.toUpperCase() }}
            —
            <samp>
              {{ fileSize }}
            </samp>
          </small>
        </p>
      </div>
    </div>
  </NuxtLink>
</template>

<style scoped lang="sass">
samp
  font-family: 'Pragmatica', sans-serif
</style>
